import { useFormik } from "formik";
import * as Yup from "yup";
import { cancelRecheck } from "../api";
import { toast } from "react-toastify";
import { orders } from "../../../../store/queries/Orders";

const useCancelRecheckModal = ({
  refetch,
  handleClose,
  selectedId,
  dispatch,
  updateConfig,
}) => {
  const initialValues = {
    cancelreason: "",
  };
  const validation = Yup.object({
    cancelreason: Yup.string().required("Enter reason for cancellation"),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: validation,
    onSubmit: async (values) => {
      const params = {
        receipt_id: selectedId?.[0],
        reason: values.cancelreason,
      };
      cancelRecheck(params).then((response) => {
        if (response?.data?.status_code === 200) {
          toast.success(
            response?.data?.message ??
              "Certificate added to recheck list successfully"
          );
          dispatch(
            updateConfig((state) => {
              state.cancelstockState = true;
            })
          );
          handleClose();
          refetch();
          // dispatch(orders.util.invalidateTags(["Recheckdata"]))
        } else {
          toast.error(response?.message ?? "Something went wrong");
          handleClose();
          refetch();
        }
      });
    },
  });
  return { formik };
};
export default useCancelRecheckModal;
